import logo from './logo.svg';
import './App.css';
import Header from './components/header/Header';
import Home from './components/Home/Home';
import DetailView from './components/details/DetailView';
 import Cart from './components/cart/Cart';
import DataProvider from './components/context/DataProvider';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import dotenv from 'dotenv';

import React from 'react'
import { useSelector } from 'react-redux';

dotenv.config()


function App() {
  return (
    <DataProvider>
  <BrowserRouter>
      <Header/>
      <Routes>
        <Route  path='/' element={<Home/>} />
        <Route  path='/cart' element={<Cart/>}/>
        <Route   path='/product/:id' element={<DetailView/>}/>
        
      </Routes>
      
 </BrowserRouter>
 </DataProvider>
   
  );
}

export default App;
